import i18n from 'i18n';
import { ColDef } from '@ag-grid-enterprise/all-modules';
import { SnmpV3User } from 'data/snmp/snmp.types';

export enum SnmpUserActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export const newSnmpUser: SnmpV3User = {
  id: '',
  USERNAME: '',
  AUTHPASSWD: '',
  PRIVPASSWD: '',
  SECURITYLVL: 'NOAUTHNOPRIV',
  HASHTYPE: 'MD5',
  PRIVPROTO: 'DES'
};

export const snmpUserColumnDefs: ColDef[] = [
  {
    headerName: i18n.t('snmpUser.grid.username'),
    field: 'USERNAME',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'name',
    flex: 1,
    minWidth: 165,
    maxWidth: 165
  },
  {
    headerName: i18n.t('snmpUser.grid.authpassword'),
    field: 'AUTHPASSWD',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'description',
    flex: 1,
    minWidth: 165,
    maxWidth: 165
  },
  {
    headerName: i18n.t('snmpUser.grid.privatePassword'),
    field: 'PRIVPASSWD',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'description',
    flex: 1,
    minWidth: 165,
    maxWidth: 165
  },
  {
    headerName: i18n.t('snmpUser.grid.securityLevel'),
    field: 'SECURITYLVL',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    tooltipField: 'description',
    flex: 1,
    minWidth: 165,
    maxWidth: 165
  },
  {
    headerName: i18n.t('snmpUser.grid.hashType'),
    field: 'HASHTYPE',
    sortable: true,
    resizable: true,
    tooltipField: 'intfType',
    flex: 1,
    minWidth: 165,
    maxWidth: 165,
    filter: 'agTextColumnFilter',
    floatingFilter: true
  },
  {
    headerName: i18n.t('snmpUser.grid.privateProtocol'),
    field: 'PRIVPROTO',
    sortable: true,
    resizable: true,
    tooltipField: 'tlsVersion',
    flex: 1,
    minWidth: 165,
    maxWidth: 165,
    filter: 'agTextColumnFilter',
    floatingFilter: true
  }
];
